// extracted by mini-css-extract-plugin
export var active = "_003d4";
export var centerer = "_72035";
export var container = "_36062";
export var placeholder = "fca58";
export var separator = "b8eca";
export var sticky = "_7fcca";